import { render, staticRenderFns } from "./dedicated_wp_dev.vue?vue&type=template&id=15c044f5&scoped=true&"
import script from "./dedicated_wp_dev.vue?vue&type=script&lang=js&"
export * from "./dedicated_wp_dev.vue?vue&type=script&lang=js&"
import style0 from "./dedicated_wp_dev.vue?vue&type=style&index=0&id=15c044f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c044f5",
  null
  
)

export default component.exports